import React, {
    useState,
    useEffect,
    useCallback,
    useRef,
    Fragment,
} from 'react';
import moment from 'moment';
import useAuth from '../hooks/useAuth'
import Modal from '../components/common/Modal';
import Button from '../components/common/Button';
import FlexContainer from '../components/common/FlexContainer';

const SessionTimeout = () => {
    //Estados
    const [events, setEvents] = useState(['click', 'load', 'scroll']);
    const [second, setSecond] = useState(0);
    const [isOpen, setOpen] = useState(false);

    //User context
    const { authState: isLogged, logout } = useAuth();

    let timeStamp;
    let warningInactiveInterval = useRef();
    let startTimerInterval = useRef();

    //Contador de tiempo inactivo, lanza una alerta después de 60 segundos
    let timeChecker = () => {
        startTimerInterval.current = setTimeout(() => {
            let storedTimeStamp = sessionStorage.getItem('lastTimeStamp');
            warningInactive(storedTimeStamp);
        }, 60000);
    };

    //Enviar una alerta cuando falta un minuto para finzalizar o cerrar sesión cuendo el tiempo expira
    let warningInactive = (timeString) => {
        clearTimeout(startTimerInterval.current);
        warningInactiveInterval.current = setInterval(() => {
            const maxTime = 30;
            const popTime = 20;
            const diff = moment.duration(moment().diff(moment(timeString)));
            const minPast = diff.minutes();
            const leftSecond = 60 - diff.seconds();

            if (minPast === popTime) {
                setSecond(leftSecond);
                setOpen(true);
            }

            if (minPast === maxTime) {
                clearInterval(warningInactiveInterval.current);
                setOpen(false);
                sessionStorage.removeItem('lastTimeStamp');
                logout();
            }

        }, 1000);
    };

    //Resetear el intervalo de tiempo
    let resetTimer = useCallback(() => {
        clearTimeout(startTimerInterval.current);
        clearInterval(warningInactiveInterval.current);

        if (window.sessionStorage.getItem('accessToken')) {
            timeStamp = moment();
            sessionStorage.setItem('lastTimeStamp', timeStamp);
        } else {
            clearInterval(warningInactiveInterval.current);
            sessionStorage.removeItem('lastTimeStamp');
        }
        timeChecker();
        setOpen(false);
    }, []);

    // handle close popup
    const handleCloseModal = () => {
        setOpen(false);
        resetTimer();
    };

    useEffect(() => {
        //Se resetea el tiempo cada vez que hay un evento: click, recargar, o scroll
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        timeChecker();

        return () => {
            clearTimeout(startTimerInterval.current);
        };
    }, [resetTimer, events, timeChecker]);

    if (!isOpen) {
        return null;
    }

    //Modal de aviso de cierre de sesión por inactividad
    return (
        <Modal state={isOpen} setState={handleCloseModal} title="Advertencia">
            <FlexContainer>
                <p>La sesión se cerrará automáticamente en {second} segundos por inactividad</p>
                <Button>Cancelar</Button>
            </FlexContainer>
        </Modal>
    );
};



export default SessionTimeout;